import type { Tag } from '@awork/_shared/models/tag.model'
import type { ValidTaskStatusType } from '@awork/features/task/models/task-status.model'
import type { ParentTask } from '@awork/features/task/models/task.model.base'

export type ValidTaskTypes = 'projectTasks' | 'privateTasks' | 'assignedTasks'
export type ValidEntityTypes = 'projects' | 'files' | 'users'
export type TaskListMigrationOperation = 'task-to-done' | 'task-remove' | 'task-move' | 'task-delete'

export interface TaskBundleAssignmentResponse {
  id: string
  name: string
  icon: string
  onCreation: boolean
  projectStatuses?: {
    id: string
    name: string
    type: string
  }[]
}

export interface IDeleteTaskBody {
  taskIds: string[]
  deleteTimeTrackings: boolean
}

export interface IDeleteTaskStatusBody {
  taskStatusId: string
}

export interface TaskStatistics {
  statusType: ValidTaskStatusType
  count: number
  trackedDuration: number
  plannedDuration: number
}

export interface TaskStatisticsBillability {
  taskId: string
  billableDuration: number
  billedDuration: number
}

export interface BatchMoveToList {
  newTaskListId: string
  removeFromCurrentList?: boolean
}

export interface BatchMoveUnderTask {
  newParentTaskId: string
}

export interface BatchMoveTaskDates {
  daysOffset: number
}

export interface TaskStatusMappingEntry {
  oldStatusId: string
  newStatusId: string
}

export interface BatchMoveToProject {
  newProjectId: string
  newTaskStatusId?: string
  newTaskListId?: string | null
  taskStatusMapping?: TaskStatusMappingEntry[]
}

export interface BatchSetDueDate {
  newDueDate?: Date
  removeDueDate: boolean
}

export interface BatchAddTags {
  tags: Tag[]
}

export interface BatchDeleteTask {
  deleteTimeTrackings?: boolean
}

export interface BatchSetWorkType {
  newTypeOfWorkId: string
  changeTimeEntries?: boolean
}

export interface BatchAssignUsers {
  userIds?: string[]
  removeOldAssignments?: boolean
}

export interface BatchSetPrio {
  isPrio: boolean
}

export interface BatchSetStatus {
  newTaskStatusId: string
}

export type BatchRequestBody =
  | BatchSetStatus
  | BatchSetPrio
  | BatchAssignUsers
  | BatchSetWorkType
  | BatchDeleteTask
  | BatchAddTags
  | BatchSetDueDate
  | BatchMoveToProject
  | BatchMoveToList
  | BatchMoveTaskDates
  | BatchMoveUnderTask

export enum BatchOperation {
  addTags = 'addTags',
  assignUsers = 'assignUsers',
  assignUser = 'assignUser',
  unassignUsers = 'unassignUsers',
  setPrio = 'setPrio',
  setDueDate = 'setDueDate',
  setStatus = 'setStatus',
  moveToList = 'moveToList',
  deleteTask = 'deleteTask',
  setWorkType = 'setWorkType',
  moveToProject = 'moveToProject',
  copyTask = 'copyTask',
  moveTaskDates = 'moveTaskDates',
  moveUnderTask = 'moveUnderTask'
}

export const batchURLMap = {
  [BatchOperation.setPrio]: 'setprio',
  [BatchOperation.addTags]: 'addtags',
  [BatchOperation.deleteTask]: 'delete',
  [BatchOperation.assignUsers]: 'assignusers',
  [BatchOperation.unassignUsers]: 'unassignusers',
  [BatchOperation.setDueDate]: 'setdates',
  [BatchOperation.moveToList]: 'movetotasklist',
  [BatchOperation.setStatus]: 'changetaskstatus',
  [BatchOperation.setWorkType]: 'changetypeofwork',
  [BatchOperation.moveToProject]: 'movetoproject',
  [BatchOperation.copyTask]: 'copy',
  [BatchOperation.moveUnderTask]: 'moveundertask'
}

export interface ChangeSubtaskItem {
  taskId: string
  order: number
  parentId: string
  parentTask: ParentTask
}

export interface ChangeSubtaskTemplateItem {
  taskTemplateId: string
  order: number
  parentId: string
}

export interface PromoteSubtaskItem {
  taskId: string
  order?: number
  listId?: string
}
